import { render } from "./Shareholder.vue?vue&type=template&id=e191855c"
import script from "./Shareholder.vue?vue&type=script&lang=js"
export * from "./Shareholder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__